var map = {
	"./appstore.png": "./src/assets/appstore.png",
	"./arrow.png": "./src/assets/arrow.png",
	"./banner/en.png": "./src/assets/banner/en.png",
	"./banner_btn/ar.png": "./src/assets/banner_btn/ar.png",
	"./banner_btn/de.png": "./src/assets/banner_btn/de.png",
	"./banner_btn/en.png": "./src/assets/banner_btn/en.png",
	"./banner_btn/es.png": "./src/assets/banner_btn/es.png",
	"./banner_btn/fr.png": "./src/assets/banner_btn/fr.png",
	"./banner_btn/id.png": "./src/assets/banner_btn/id.png",
	"./banner_btn/it.png": "./src/assets/banner_btn/it.png",
	"./banner_btn/ja.png": "./src/assets/banner_btn/ja.png",
	"./banner_btn/ko.png": "./src/assets/banner_btn/ko.png",
	"./banner_btn/ms.png": "./src/assets/banner_btn/ms.png",
	"./banner_btn/pl.png": "./src/assets/banner_btn/pl.png",
	"./banner_btn/pt.png": "./src/assets/banner_btn/pt.png",
	"./banner_btn/ru.png": "./src/assets/banner_btn/ru.png",
	"./banner_btn/th.png": "./src/assets/banner_btn/th.png",
	"./banner_btn/tr.png": "./src/assets/banner_btn/tr.png",
	"./banner_btn/vi.png": "./src/assets/banner_btn/vi.png",
	"./banner_btn/zh-TW.png": "./src/assets/banner_btn/zh-TW.png",
	"./btn_go.png": "./src/assets/btn_go.png",
	"./btn_pay.png": "./src/assets/btn_pay.png",
	"./btn_pay2.png": "./src/assets/btn_pay2.png",
	"./btns/a_pay_btn.png": "./src/assets/btns/a_pay_btn.png",
	"./btns/a_pay_btn2.png": "./src/assets/btns/a_pay_btn2.png",
	"./close.png": "./src/assets/close.png",
	"./down_arrows_left.png": "./src/assets/down_arrows_left.png",
	"./down_arrows_right.png": "./src/assets/down_arrows_right.png",
	"./download.png": "./src/assets/download.png",
	"./download_bkg.png": "./src/assets/download_bkg.png",
	"./download_soldiers.png": "./src/assets/download_soldiers.png",
	"./download_soldiers_small.png": "./src/assets/download_soldiers_small.png",
	"./google-play.png": "./src/assets/google-play.png",
	"./herotitle.png": "./src/assets/herotitle.png",
	"./logo.png": "./src/assets/logo.png",
	"./mobile_arrows.png": "./src/assets/mobile_arrows.png",
	"./mobile_dowj_ft.png": "./src/assets/mobile_dowj_ft.png",
	"./pay_modal.png": "./src/assets/pay_modal.png",
	"./pc_tips.png": "./src/assets/pc_tips.png",
	"./pcdown.png": "./src/assets/pcdown.png",
	"./play.png": "./src/assets/play.png",
	"./playBtn.png": "./src/assets/playBtn.png",
	"./shell.png": "./src/assets/shell.png",
	"./slogan.png": "./src/assets/slogan.png",
	"./spritesheet30.png": "./src/assets/spritesheet30.png",
	"./video_01.png": "./src/assets/video_01.png",
	"./video_02.png": "./src/assets/video_02.png",
	"./windows_down_m.png": "./src/assets/windows_down_m.png",
	"./windows_top.png": "./src/assets/windows_top.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.png$";